// ---------------------------------------------------------------------------
// releaseNotes/version — Versionsnummern vergleichen (NEU-1). Reine Funktionen.
// ---------------------------------------------------------------------------
// Das OS traegt seine Version als `MAJOR.MINOR.PATCH` (app-version.json). Ein
// Textvergleich waere falsch («6.9.0» > «6.637.0»); hier wird pro Stelle als
// Zahl verglichen. Es gibt keine semver-Abhaengigkeit im Repo, und mehr als
// drei Zahlen braucht das Haus nicht.

export const VERSION_PATTERN = /^\d+\.\d+\.\d+$/;

export type VersionTriple = readonly [number, number, number];

export function isVersionString(value: string): boolean {
  return VERSION_PATTERN.test(value);
}

/** `null` fuer alles, was keine `a.b.c`-Version ist — auch fuer «dev». */
export function parseVersion(value: string): VersionTriple | null {
  if (!VERSION_PATTERN.test(value)) return null;
  const [a, b, c] = value.split(".").map((part) => Number.parseInt(part, 10));
  if (a === undefined || b === undefined || c === undefined) return null;
  return [a, b, c];
}

/** -1 wenn a < b, 0 bei Gleichstand, 1 wenn a > b. Beide muessen gueltig sein. */
export function compareVersions(a: string, b: string): -1 | 0 | 1 {
  const pa = parseVersion(a);
  const pb = parseVersion(b);
  if (!pa || !pb) {
    throw new Error(`compareVersions: ungueltige Version (${a} / ${b})`);
  }
  for (let i = 0; i < 3; i += 1) {
    const x = pa[i] ?? 0;
    const y = pb[i] ?? 0;
    if (x < y) return -1;
    if (x > y) return 1;
  }
  return 0;
}

/**
 * Liegt `version` im Fenster «nach der Gesehen-Marke, spaetestens die laufende
 * Server-Version»? Eine ungueltige Server-Version («dev» im lokalen Lauf)
 * oeffnet das Fenster nach oben — lokal soll jede Zeile sichtbar sein, die
 * jemand geschrieben hat.
 */
export function isVersionInWindow(args: {
  version: string;
  seenVersion: string;
  serverVersion: string;
}): boolean {
  if (compareVersions(args.version, args.seenVersion) <= 0) return false;
  if (parseVersion(args.serverVersion) === null) return true;
  return compareVersions(args.version, args.serverVersion) <= 0;
}
